module.exports = __webpack_public_path__ + "img/no_preview_available.b15a57fa.jpg";